export const globalSettings = {
  url: 'https://api.1touchrevolution.com/v1/super-admin'
      // url: 'https://api.1touch.binariks.org/v1/super-admin',
    // todo
      // url: 'https://binariks.org/v1/super-admin',
}



// WEBPACK FOOTER //
// C:/www/onetouchSuperAdmin/src/app/shared/config.ts